import React from 'react';
import { Box, CloseButton, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import SidebarMenu from './sidebar-menu';
import { useSelector } from 'react-redux';
import { BaseLocatization } from '../../modules/base-locatization/base-locatization'

function Sidebar({ onClose }) {

  const user = useSelector(state => state.userState.user);

  const getUserName = () => {
    if (user && user.displayName) {
      console.log(user);
      const words = user.displayName.split(' ');
      const capitalized = words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
      return `${BaseLocatization.greetings} ${capitalized}`;
    }
    return BaseLocatization.AdminPanel;
  }

  return (
    <Flex
      bg={useColorModeValue('white', 'gray.700')}
      borderRight='1px'
      borderRightColor={useColorModeValue('gray.200', 'gray.900')}
      w={{ base: 'full', md: 60 }}
      pos='fixed'
      h='full'
      direction='column'
    >
      <Flex h='20' alignItems='center' mx='8' justifyContent='space-between'>
        <Text fontSize='xl' fontFamily='monospace' fontWeight='bold' data-testid="side-bar-title" whiteSpace="normal" wordBreak="break-word" lineHeight="1.2" mt={2} mb={2}>
          Welcome
        </Text>
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      <Box flex='1' overflowY='auto'>
        <SidebarMenu onClose={onClose} mode="top" />
      </Box>
      <Box mt='auto' borderTopWidth='1px' py='4'>
        <SidebarMenu onClose={onClose} mode="bottom" />
      </Box>
    </Flex>
  );
}

export default Sidebar;